<template>
  <div class="pay_sucess">
    <titleBar :title="title"></titleBar>
    <div class="head">
      <div class="sucess_word">
        <i></i>
        支付成功
      </div>
    </div>
    <div class="content">
      <p class="word_b">
        <i></i>
        <span>{{word_a[type]}}</span>
        <i></i>
      </p>
      <p class="word_s">{{word_b[type]}}</p>
      <div class="codeItem">
        <img :src="img_url" />
      </div>
      <p class="btn" @click="copyImg">保存二维码至相册</p>
      <p class="word_b">
        <i></i>
        <span>{{word_c[type]}}</span>
        <i></i>
      </p>
      <p class="word_s">只需三步立即完成</p>
      <img class="mr_t70" src="../../assets/images/pay_sucess_word.png" />
    </div>
    <div v-if="mask" class="mask" @touchmove.prevent>
      <div class="tips">
        <h3>{{copyMes}}</h3>
        <p @click="go_weixin">{{copyBtn}}</p>
      </div>
    </div>
  </div>
</template>

<script>
import ajax from "@/api/ajax";
import utils from "@/assets/js/utils";
import titleBar from "@/components/common/titleBar.vue";
import titleImg from "@/assets/images/codeImg.jpg";
var vm = null;
window.callback = function(status) {
  if (status == "success") {
    vm.showMask(true);
  } else {
    vm.showMask(false);
  }
};
export default {
  name: "pay_sucess",
  data() {
    return {
      mask: false,
      img_url: "",
      type: 3,
      title: "支付结果",
      copyMes: "二维码成功保存至相册",
      copyBtn: "打开微信扫描二维码",
      copyStatus: true,
      word_a: {
        1: "添加微信",
        2: "添加微信群",
        3: "关注公众号"
      },
      word_b: {
        1: "加辅导老师微信，一对一辅导学习",
        2: "获取上课提醒，一对一辅导学习",
        3: "关注公众号  获取上课提醒"
      },
      word_c: {
        1: "如何加老师微信？",
        2: "如何加入微信群？",
        3: "如何关注公众号？"
      }
    };
  },
  methods: {
    initData: async function() {
      let token = utils.getQueryString("token");
      let sourceId = utils.getQueryString("sourceId");
      let version = utils.getQueryString("version");
      let source = utils.getQueryString("source");
      const [resp] = await ajax.all([
        ajax.get("/parent/live/get-bought-qrcode", {
          params: {
            token: token,
            version: version,
            source: source,
            classNumbers: sourceId
          }
        })
      ]);
      console.log(resp.data);
      if (resp.data.code == 99999) {
        let type = resp.data.data.type;
        this.img_url = resp.data.data.url
          ? resp.data.data.url
          : window.location.origin + "/" + titleImg;
        if (type == 1 || type == 2 || type == 3) {
          this.type = type;
        }
      }
    },
    copyImg: function() {
      if (this.copyStatus) {
        window.location =
          "hybird://method/savePhoto?url=" +
          decodeURI(this.img_url) +
          "&jsCallBack=callback";
      }
    },
    showMask: function(status) {
      window.console.log(status);
      if (status) {
        this.copyMes = "二维码成功保存至相册";
        this.copyBtn = "打开微信扫描二维码";
      } else {
        this.copyMes = "二维码保存失败";
        this.copyBtn = "重新保存二维码";
      }
      this.mask = true;
      this.copyStatus = status;
    },
    go_weixin: function() {
      this.mask = false;
      if (this.copyStatus) {
        var url = "hybird://method/openBrowser?url=weixin://scanqrcode";
        window.location = url;
      }
    }
  },
  components: {
    titleBar
  },
  created: async function() {
    let self = this;
    vm = this;
    await self.initData();
  }
};
</script>

<style lang="scss" scoped>
.pay_sucess {
  .head {
    padding-top: 1.5rem;
    height: 3.43rem;
    background-color: #f8f9fd;
    .sucess_word {
      height: 0.5rem;
      line-height: 0.5rem;
      text-align: center;
      font-family: PingFangSC-Medium;
      font-size: 0.38rem;
      color: #21bd0a;
      i {
        display: inline-block;
        width: 0.5rem;
        height: 0.5rem;
        background: url("../../assets/images/pay_sucess_icon.png") 0 0 / cover
          no-repeat;
        vertical-align: text-bottom;
      }
    }
    p {
      margin: 0.33rem auto 0;
      width: 2.18rem;
      height: 0.68rem;
      line-height: 0.68rem;
      border-radius: 0.34rem;
      border: solid 1px #d6d8e9;
      font-family: PingFangSC-Regular;
      font-size: 0.28rem;
      color: #616161;
      text-align: center;
    }
  }
  .content {
    padding-top: 0.8rem;
    background-color: #fff;
    .word_b {
      margin-bottom: 0.2rem;
      text-align: center;
      i {
        display: inline-block;
        width: 0.19rem;
        height: 0.04rem;
        background-color: #4b79f6;
        border-radius: 2px;
        margin-bottom: 0.12rem;
      }
      span {
        padding: 0 0.15rem;
        font-family: FZY4JW--GB1-0;
        font-size: 0.4rem;
        color: #4b79f6;
        font-weight: bold;
      }
    }
    .word_s {
      height: 0.26rem;
      line-height: 0.26rem;
      font-family: FZY4JW--GB1-0;
      font-size: 0.26rem;
      font-weight: bold;
      color: #a8a9b5;
      text-align: center;
    }
    .codeItem {
      position: relative;
      margin: 0.6rem auto 0.6rem;
      width: 6.04rem;
      height: 4.34rem;
      background: url("../../assets/images/pay_sucess_bg.png") 0 0 / cover
        no-repeat;
      img {
        position: absolute;
        width: 2.21rem;
        height: 2.21rem;
        left: 0;
        right: 0;
        margin: 1.3rem auto;
      }
    }
    .btn {
      margin: 0 auto 0.9rem;
      width: 5rem;
      height: 1rem;
      line-height: 1rem;
      background-color: #84a4fa;
      border-radius: 0.5rem;
      font-family: PingFangSC-Medium;
      font-size: 0.34rem;
      color: #ffffff;
      text-align: center;
    }
    .mr_t70 {
      margin-top: 0.7rem;
    }
    img {
      width: 100%;
    }
  }
  .mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6);
    .tips {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      margin: auto;
      width: 5.8rem;
      height: 3.64rem;
      background-color: #ffffff;
      border-radius: 0.3rem;
      h3 {
        margin: 1rem 0 0.8rem;
        font-family: PingFangSC-Medium;
        font-size: 0.36rem;
        color: #56586a;
        text-align: center;
      }
      p {
        margin: 0 auto;
        width: 5rem;
        height: 0.9rem;
        line-height: 0.9rem;
        background-color: #e7be84;
        border-radius: 0.45rem;
        font-family: PingFangSC-Medium;
        font-size: 0.32rem;
        color: #ffffff;
        text-align: center;
      }
    }
  }
}
</style>